var cilDollar = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M296,240H216a46.222,46.222,0,1,1,0-92.444H344v-32H276V56H244v59.556H216A78.222,78.222,0,0,0,216,272h80a46.274,46.274,0,0,1,46.222,46.222v3.556A46.274,46.274,0,0,1,296,368H160.593v32H244v56h32V400h20a78.31,78.31,0,0,0,78.222-78.222v-3.556A78.31,78.31,0,0,0,296,240Z' class='ci-primary'/>"];

export { cilDollar };
//# sourceMappingURL=cil-dollar.js.map
